import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { authApi, saveToken } from "@/lib/adminApi";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await authApi.post("/admin/login", { email, password });
      saveToken(data.token);
      toast.success("Connexion réussie");
      navigate("/admin/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Erreur de connexion";
      toast.error(typeof msg === "string" ? msg : "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-br from-secondary via-secondary to-black px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_exterior-clean-pro-1/artifacts/11ya2fow_Lavage.png"
            alt="Pro-Jet Nettoyage"
            className="h-20 w-auto object-contain mx-auto mb-4 brightness-0 invert"
          />
          <h1 className="text-2xl font-semibold text-white">Espace administrateur</h1>
        </div>

        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl space-y-5" data-testid="admin-login-form">
          <div>
            <Label htmlFor="admin-email" className="text-secondary mb-2 block">Courriel</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <Input
                id="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@exemple.com"
                className="pl-10 bg-gray-50/70"
                data-testid="admin-login-email"
                required
              />
            </div>
          </div>

          <div>
            <Label htmlFor="admin-password" className="text-secondary mb-2 block">Mot de passe</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <Input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="pl-10 bg-gray-50/70"
                data-testid="admin-login-password"
                required
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-primary hover:bg-primary/90 rounded-xl py-6 font-semibold"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>

        <a href="/" className="block text-center mt-6 text-sm text-white/60 hover:text-white" data-testid="admin-back-home">
          ← Retour au site
        </a>
      </div>
    </div>
  );
}
